import React, { useState, useEffect } from "react";
import { updatePwd } from "../../services/loginService";
import { useLocation, useNavigate } from "react-router-dom";

const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [matchError, setMatchError] = useState("");
  const [isMatch, setIsMatch] = useState(false);
  const [lengthError, setLengthError] = useState("");
  const [email, setEmail] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  // Real-time check as user types
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const emailParam = params.get("email");
    if (emailParam) {
      setEmail(emailParam);
    }

    if (password.length < 8 || password.length > 20) {
      setLengthError("Password must be 8–20 characters long.");
    } else {
      setLengthError("");
    }

    if (confirmPassword === "") {
      setMatchError("");
      setIsMatch(false);
    } else if (password === confirmPassword) {
      setMatchError("");
      setIsMatch(true);
    } else {
      setMatchError("Passwords do not match.");
      setIsMatch(false);
    }
  }, [password, confirmPassword, location.search]);

  let data = {};
  data.email = email;
  data.password = password;

  const handleSubmit = async (e) => {
    console.log(password);
    e.preventDefault();
    updatePwd(data)
      .then((response) => {
        let token = response.data.data.token;
        localStorage.setItem("token", token);
        navigate("/createtweet", { replace: true });
        navigate(0);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="flex min-h-full flex-1">
      <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div>
            <h1 className="mt-8 text-2xl font-bold tracking-tight text-gray-900">
              BlogSlicer
            </h1>
            <h2 className="mt-4 text-xl font-semibold text-gray-800">
              Set Your Password
            </h2>
            <p className="mt-2 text-sm text-gray-500">
              Please set a secure password to access your dashboard.
            </p>
          </div>

          <div className="mt-10">
            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* Password */}
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-900"
                >
                  Password
                </label>
                <div className="mt-2">
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={8}
                    maxLength={20}
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600 sm:text-sm"
                  />
                </div>
              </div>

              {/* Confirm Password */}
              <div>
                <label
                  htmlFor="confirmPassword"
                  className="block text-sm font-medium text-gray-900"
                >
                  Confirm Password
                </label>
                <div className="mt-2">
                  <input
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 focus:outline-indigo-600 sm:text-sm"
                  />
                </div>
              </div>
              {matchError && (
                <p className="mt-1 text-sm text-red-600">{matchError}</p>
              )}
              {!matchError && confirmPassword && (
                <p className="mt-1 text-sm text-green-600">
                  ✅ Passwords match!
                </p>
              )}

              {/* Error or Success Message */}
              {error && (
                <p className="text-sm text-red-600 font-medium">{error}</p>
              )}
              {success && (
                <p className="text-sm text-green-600 font-medium">{success}</p>
              )}

              {/* Submit Button */}
              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-indigo-600"
                >
                  Set Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="relative hidden w-0 flex-1 lg:block min-h-[720px]">
        <img
          alt=""
          src="https://images.unsplash.com/photo-1496917756835-20cb06e75b4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1908&q=80"
          className="absolute inset-0 size-full object-cover"
        />
      </div>
    </div>
  );
};

export default SetPassword;
